export const containerLoadPointer = {
  locationTermsListFcl: "fclLocationTermsTranslation",
  locationTermsListLcl: "lclLocationTermsTranslation",
  locationTermsListAir: "airLocationTermsTranslation",
  locationTermsListLtl: "ltlLocationTermsTranslation",
  locationTermsModelFcl: "fclTranslations",
  locationTermsModelLcl: "lclTranslations",
  locationTermsModelAir: "airTranslations",
  locationTermsModelLtl: "ltlTranslations",
};
